<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <!-- Bookmarks Container -->
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <search-bar />
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt';
import { initialAbility } from '@/libs/acl/config';
import axios from 'axios';
import { BLink, BNavbarNav } from 'bootstrap-vue';
import DarkToggler from './components/DarkToggler.vue';
import SearchBar from './components/SearchBar.vue';
import UserDropdown from './components/UserDropdown.vue';
export default {
  components: {
    BLink,
    BNavbarNav,
    SearchBar,
    DarkToggler,
    UserDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  async created() {
    this.$store.commit('appConfig/UPDATE_CONTENT_WIDTH', 'boxed');

    // Wait a bit for the store to be properly initialized
    await this.$nextTick();

    // Skip authentication check during login process
    if (this.$route.name === 'auth-login') {
      return;
    }

    // Wait longer for the store to be fully ready after login
    await new Promise((resolve) => setTimeout(resolve, 1000));

    // Skip authentication check if store is not ready yet
    if (!this.$store.state.user || !this.$store.state.user.token) {
      return;
    }

    // Only check authentication for logged-in users on protected routes
    if (this.$store.state.user.isLoggedIn) {
      if (!this.$store.state.user.passEntered) {
        this.logout();
        return;
      }

      // Check login validity - try simple validation first

      // Simple validation: check if we have valid stored data
      if (
        this.$store.state.user.token &&
        this.$store.state.user.user &&
        this.$store.state.user.passEntered
      ) {
        return;
      }

      // If simple validation fails, try API validation
      const check = await this.checkLogin();
      if (!check) {
        this.logout();
      }
    }
  },
  methods: {
    async checkLogin() {
      try {
        // Check if we have the required data
        if (
          !this.$store.state.user.user ||
          !this.$store.state.user.user.username ||
          !this.$store.state.user.passEntered
        ) {
          return false;
        }

        var config = {
          method: 'post',
          url: process.env.VUE_APP_API_URL + 'Users/Login',
          data: {
            username: this.$store.state.user.user.username,
            password: this.$store.state.user.passEntered,
          },
          timeout: 10000, // 10 second timeout
          headers: {
            'Content-Type': 'application/json',
          },
        };

        var response = await axios(config);

        let resp = response.data.data;

        if (response.data.status == 'success') {
          if (resp.user.status == 'active' && resp.user.forms) {
            // Use the new user module to store user data
            this.$store.dispatch('user/login', {
              token: resp.token,
              user: resp.user,
            });
            this.$store.commit('setToken', resp.token);

            // set rights object for auth routes
            let rights = {};
            if (this.$store.state.user.userRights && this.$store.state.user.userRights.length > 0) {
              this.$store.state.user.userRights.forEach((el) => {
                if (el.children && el.children.length > 0) {
                  el.children.forEach((ch) => {
                    rights[ch.route] = { ...ch };
                  });
                }
              });
              this.$store.commit('user/SET_AUTH_ROUTES', rights);
            }

            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.error('Login check error:', error);
        console.error('Error details:', {
          message: error.message,
          response: error.response?.data,
          status: error.response?.status,
          config: error.config,
        });
        return false;
      }
    },
    logout() {
      // Remove JWT data from localStorage
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName);
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName);
      localStorage.removeItem('userData');

      // Reset ability
      this.$ability.update(initialAbility);

      // Use the logout method from our mixin to clear user data from Vuex
      this.$store.dispatch('user/logout');

      // Check if we're already on the login page to prevent navigation duplication
      if (this.$route.name !== 'auth-login') {
        // Only navigate if not already on a login page
        this.$router.push({ name: 'auth-login' }).catch((err) => {
          // Ignore navigation errors
          if (err.name !== 'NavigationDuplicated') {
            console.error('Navigation error:', err);
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.navbar-container {
  z-index: 1000 !important;
}
</style>
